module.exports = __webpack_public_path__ + "static/office-spaces-ce7167b8e8dd28da7118687587184066.jpg";